import { tax_id_types } from 'lib/constants/constants';
import { ia } from 'lib/helpers/utility';

import Actions from '../components/Actions';

export const getDefaultColumns = (states) => {
  const stateFormatter = ({ value }) =>
    states?.find((state) => state.id === Number(value))?.name || 'Unknown';

  return [
    {
      field: 'id',
      headerName: 'ID'
    },
    {
      field: 'bill_name',
      headerName: 'Billing Name'
    },
    {
      field: 'bill_npi',
      headerName: 'Billing NPI'
    },
    {
      field: 'bill_taxid',
      headerName: 'Billing Tax ID'
    },
    {
      field: 'bill_taxid_type',
      headerName: 'Tax ID Type',
      valueFormatter: ({ value }) => {
        return tax_id_types.find((type) => type.value === value)?.label || 'Unknown';
      }
    },
    { field: 'bill_taxonomy', headerName: 'Taxonomy' },
    { field: 'bill_id', headerName: 'Atypical ID' },
    { field: 'bill_addr_1', headerName: 'Address 1' },
    { field: 'bill_addr_2', headerName: 'Address 2' },
    { field: 'bill_city', headerName: 'City' },
    {
      field: 'bill_state',
      headerName: 'State',
      valueFormatter: stateFormatter
    },
    { field: 'bill_zip', headerName: 'Zip' },
    { field: 'bill_phone', headerName: 'Phone' },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      cellRenderer: (params) => <Actions data={params?.data} />,
      maxWidth: 100,
      minWidth: 36,
      resizable: false,
      sortable: false,
      pinned: 'right'
    }
  ];
};

export const findSelectedUsers = (selectedValue, members) =>
  members?.filter((member) => selectedValue?.includes(member?.value)) || [];

export const selectUsers = (members, formik) => {
  const result = members?.map((member) => member?.value) || [];
  formik.setFieldValue('practitioner_ids', ia(result) ? result : []);
};

export const findSelectedState = (states, bill_state) => {
  return states?.find((s) => s?.value == bill_state) || null;
};
